import type { ReactNode } from 'react';

type Tone = 'info' | 'success' | 'warning' | 'error';

const toneClasses: Record<Tone, string> = {
  info: 'border-neutral-200 bg-neutral-50 text-neutral-800 dark:border-neutral-800 dark:bg-neutral-900 dark:text-neutral-200',
  success:
    'border-emerald-200 bg-emerald-50 text-emerald-900 dark:border-emerald-900 dark:bg-emerald-950 dark:text-emerald-100',
  warning:
    'border-amber-200 bg-amber-50 text-amber-900 dark:border-amber-900 dark:bg-amber-950 dark:text-amber-100',
  error:
    'border-red-200 bg-red-50 text-red-900 dark:border-red-900 dark:bg-red-950 dark:text-red-100',
};

interface NoticeProps {
  tone?: Tone;
  children: ReactNode;
  /** Use `alert` for errors that must interrupt; `status` for everything else. */
  role?: 'status' | 'alert';
  className?: string;
}

export function Notice({ tone = 'info', children, role, className = '' }: NoticeProps) {
  const resolvedRole = role ?? (tone === 'error' ? 'alert' : 'status');
  return (
    <div
      role={resolvedRole}
      aria-live={resolvedRole === 'alert' ? 'assertive' : 'polite'}
      className={`rounded-md border px-3 py-2.5 text-sm leading-snug ${toneClasses[tone]} ${className}`}
    >
      {children}
    </div>
  );
}
